const filterByString = searchString => ([id, provider]) => {
  const fields = [provider.name]
  return fields.reduce(
    (match, value) =>
      match
        ? match
        : String(value)
            .toLowerCase()
            .includes(searchString.toLowerCase()),
    false
  )
}

export default filterByString



// WEBPACK FOOTER //
// ./src/views/ProviderList/Main/helpers/filter-by-string.js